import { defineAsyncComponent } from 'vue'
import { tabOutlineBinaryTree } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type {
  FeatureConfig,
  MainFeatureTwin,
  FeatureQueryTwin,
  FeatureParameterConfigs
} from 'src/models'
import type { QueryConfig } from 'src/composables/use-query'
import type { QUERY_KIND } from 'src/services/constants'

/** dtmi:com:arcadis:app:TreeFeature;2 */
export interface TreeFeatureTwin extends MainFeatureTwin, QueryConfig {
  loadDrawerFeature?: string
  filter?: boolean
  queryKind?: QUERY_KIND
  query?: string
  itemLabel?: string
  itemColor?: string
  relationshipName?: string
  viewerIsolateItems?: boolean
  parameters?: FeatureParameterConfigs
  /** Automatically sync selected twins to the store when selection changes */
  syncSelection?: boolean
  /** Always fetch selected twins from API even if already in the store */
  syncSelectionOverwrite?: boolean
}

/** dtmi:com:arcadis:app:TreeQuery;2 */
export interface TreeQueryTwin extends FeatureQueryTwin, QueryConfig {
  itemLabel?: string
  itemColor?: string
  relationshipName?: string
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./TreeFeatureMain.vue')),
    splitter: 450,
    icon: tabOutlineBinaryTree,
    label: 'Tree'
  }
}

export default featureConfig
